import { render, staticRenderFns } from "./xm-dict-select.vue?vue&type=template&id=fb2d8936&scoped=true"
import script from "./xm-dict-select.vue?vue&type=script&lang=js"
export * from "./xm-dict-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17.21_prettier@2.8.8_vue-temp_pgqv4bjfw4n43uthtcnbh5tcie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2d8936",
  null
  
)

export default component.exports